import { EventEmitter, Injectable, Type } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';

import { ComponentLoaderService, ComponentProxy } from '../deferred/component-loader.service';
import ModuleLoaderService from '../deferred/module-loader.service';
import { VideoStreamModule } from './video-stream.module';

export interface EventVideoStreamBinding {
    event: EventModel;
    inColumn?: boolean;
    autoplay?: boolean;
    isExpanded: boolean;
    isExpandEnabled: boolean;
    trackingSource: string;
    showVideoPin: boolean;
    videoPinToggle: EventEmitter<boolean>;
    toggleMediaExpand: EventEmitter<void>;
}

@Injectable({ providedIn: 'root' })
export class VideoStreamComponentLoaderService extends ComponentLoaderService<VideoStreamModule> {
    moduleName = 'VideoStreamModule';

    constructor(moduleLoader: ModuleLoaderService, loggerFactory: LoggerFactory) {
        super(moduleLoader, loggerFactory);
    }

    getVideoStreamComponent(): ComponentProxy<EventVideoStreamBinding> {
        return this.getComponentProxy((module) => module.videoStreamComponent);
    }

    getModule(): Promise<Type<VideoStreamModule>> {
        return import('./video-stream.module').then((m) => m.VideoStreamModule);
    }
}
